module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":"Name","select":"Select","category":"Category","default":"Default","min_value":"Min value","max_value":"Max value"},"de":{"name":"Name","select":"Wählen","category":"Kategorie","default":"Standard","min_value":"Mindestwert","max_value":"Maximalwert"}}')
  delete Component.options._Ctor
}
